/** API category labels (lowercase). Empty/missing → backend defaults to "other". */
export const normalizeCategory = (value) => {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return 'other';
  return trimmed.toLowerCase();
};

export const formatCategoryLabel = (category) => {
  const normalized = normalizeCategory(category);
  if (normalized === 'other') return 'Other';
  return normalized
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
};

export const getDueCancelReason = (due) => {
  if (!due) return '';
  const metadata =
    due.metadata && typeof due.metadata === 'object' ? due.metadata : {};
  const status = String(due.status || '').toLowerCase();
  const candidates = [
    due.cancel_reason,
    due.cancelReason,
    due.cancellation_reason,
    due.cancellationReason,
    metadata.cancel_reason,
    metadata.cancellation_reason,
    metadata.cancelReason,
    ...(status === 'cancelled' || status === 'canceled' ? [due.reason] : []),
  ];
  for (const value of candidates) {
    const text = String(value ?? '').trim();
    if (text) return text;
  }
  return '';
};

export const DUE_CATEGORY_OPTIONS = [
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'water', label: 'Water' },
  { value: 'security', label: 'Security' },
  { value: 'penalty', label: 'Penalty' },
  { value: 'parking', label: 'Parking' },
  { value: 'other', label: 'Other' },
];

export const toApiLineItems = (items) =>
  items.map((li) => {
    const quantity = Number(li.quantity) || 0;
    const pricePerUnit = Number(li.price_per_unit) || 0;
    const subtotal = quantity * pricePerUnit;
    return {
      name: String(li.name || '').trim(),
      quantity,
      unit: String(li.unit || '').trim(),
      price_per_unit: pricePerUnit,
      subtotal,
    };
  });
